import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { IcLock } from "./Icons";

/**
 * Giriş yapılmamışsa /login'e yönlendirir.
 * requiredRole verilmişse role kontrolü de yapar: yetkisizse 403 ekranı.
 */
export default function ProtectedRoute({ children, requiredRole }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="auth-loading-spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && user.role !== requiredRole) {
    return (
      <div className="unauthorized-page">
        <div className="unauthorized-box">
          <div className="unauthorized-icon"><IcLock size={44} /></div>
          <h2>Yetkisiz Erişim</h2>
          <p>Bu sayfaya erişim yetkiniz yok.</p>
          <p className="unauthorized-role">
            Rolünüz: <strong>{user.role}</strong>
          </p>
        </div>
      </div>
    );
  }

  return children;
}
